<template>
  <div>
    <div class="table_description table_description_filter">
      <div class="tertiary_color text_left">
        <div> {{ $t("trackPay.debtorContractsTable.tip1") }}
        </div>
        <div>
          {{ $t("trackPay.debtorContractsTable.tip2") }}
        </div>
        <div>
          {{ $t("trackPay.debtorContractsTable.tip3") }}
        </div>
      </div>
    </div>
    <div class="flex filter_table">
      <div class="flex flex_column w_100">
        <AgItem
          v-on:getGridApi="getGridApi"
          :rowData="rowData"
          :columnDefs="columnDefs"
          v-on:sortChanged="sortChanged"
          :frameworkComponents="frameworkComponents"
        ></AgItem>
        <Pagination
          :totalNum="totalNum"
          :pageSize="pageSize"
          :sizeChange="sizeChange"
          :currentChange="currentChange"
          :currentPage="page"
        ></Pagination>
      </div>
    </div>
    <DebtorContractModal
      @reject="reject"
      :contractData="activeData"
      ref="relationModal"
      @success="getList"
    ></DebtorContractModal>
    <RejectModal
      ref="rejectModal"
      :contractData="activeData"
      @success="getList"
    ></RejectModal>
    <TrackProgressModal :isDebtor="true" ref="TrackProgressModal" @change="getList"></TrackProgressModal>
  </div>
</template>

<script>
import AgItem from "src/components/templates/agGrid/AgItem.vue";
import Pagination from "src/components/templates/common/Pagination.vue";
import PaginationParent from "src/components/templates/common/PaginationParent.vue";
import DebtorContractModal from "@/components/templates/trackPay/debtor/DebtorContractModal";
import RejectModal from "@/components/templates/trackPay/debtor/RejectModal";
import {trackPayApi} from "@/common/api/trackPayApi";
import {asDecimal, asLocalizedDate, asMoneyAmount} from "@/components/templates/agGrid/formatter/valueFormatters";
import TrackProgressModal from "@/components/templates/trackPay/TrackProgressModal";

export default {
  extends: PaginationParent,
  components: {
    AgItem,
    Pagination,
    DebtorContractModal,
    RejectModal,
    TrackProgressModal
  },
  data() {
    return {
      rowData: [{}],
      columnDefs: [],
      gridApi: null,
      filters: [],
      sorting: [],
      activeData: {}
    };
  },
  beforeMount() {
    this.setColumnDefs();
    this.getList();
  },
  methods: {
    sortChanged(sortData) {
      this.sorting = sortData;
      this.initPage();
      this.getList();
    },
    getGridApi(gApi) {
      this.gridApi = gApi;
    },
    setColumnDefs() {
      this.columnDefs = [
        {
          headerName: this.$t("trackPay.debtorContractsTable.Supplier"),
          children: [
            {
              headerName: this.$t("common.label.name"),
              field: "supplierName",
              minWidth: 300,
              sortable: true
            }
          ]
        },
		{
          headerName: this.$t("trackPay.contractsTable.contract"),
          children: [
            {
              headerName: this.$t("trackPay.id"),
              field: "uuid",
              minWidth: 150,
              sortable: true,
            },
            {
              headerName: this.$t("common.orderNumber"),
              field: "invoiceNumber",
              sortable: true,
              minWidth: 200
            }
          ]
        },
        {
          headerName: this.$t("trackPay.contractsTable.dispatchAddress"),
          children: [
            {
              headerName: this.$t("common.country"),
              field: "fromCountry",
              sortable: true,
              minWidth: 100
            }
          ]
        },
        {
          headerName: this.$t("trackPay.contractsEditModal.delivery"),
          children: [
            {
              headerName: this.$t("trackPay.contractsEditModal.latitude"),
              field: "latitude",
              sortable: true,
              minWidth: 130,
              valueFormatter:
                  asDecimal({
                    showZeroAsNotAvailable: true,
                    showEmptyAsNotAvailable: true,
                    decimals: 10})
            },
            {
              headerName: this.$t("trackPay.contractsEditModal.longitude"),
              field: "longitude",
              minWidth: 130,
              sortable: true,
              valueFormatter:
                  asDecimal({
                    showZeroAsNotAvailable: true,
                    showEmptyAsNotAvailable: true,
                    decimals: 10})
            }
          ]
        },
        {
          headerName: this.$t("trackPay.contractsTable.shipment"),
          children: [
            {
              headerName: this.$t("common.amount"),
              field: "amount",
              sortable: true,
              minWidth: 130,
              valueFormatter: asMoneyAmount()
            },
            {
              headerName: this.$t("common.ccy"),
              field: "currency",
              minWidth: 80,
              sortable: true,
            },
            {
              headerName: this.$t("trackPay.contractsTable.shipDate"),
              field: "invoiceDate",
              valueFormatter: asLocalizedDate(),
              minWidth: 100,
              sortable: true
            }
          ]
        },
        {
          headerName: this.$t("common.progress"),
          headerClass: "bg_special",
		  maxWidth: 500,
          children: [
            {
              headerName: this.$t("trackPay.contractsTable.currentState"),
              cellRendererFramework: "ShipmentProgressStatus",
              cellRendererParams: {
                companyType: "debtor"
              },
              minWidth: 210,
              maxWidth: 210,
			  pinned: "right"
            },
            {
              headerName: this.$t("trackPay.table.scheduled"),
              minWidth: 200,
              cellRendererFramework: "ContractStatusScheduled",
              cellRendererParams: {
                companyType: "debtor"
              },
              pinned: "right",
            },
            {
              headerName: this.$t("common.actions"),
              cellRendererFramework: "DebtorContractAction",
              cellRendererParams: {
                showDetail: this.showDetail,
                showTrackingDetail: this.showTrackingDetail,
                delContract: this.delContract,
              },
              minWidth: 90,
			  maxWidth: 110,
              pinned: "right",
            }
          ],
          pinned: "right",
        }
      ];
    },
    delContract(id) {
      trackPayApi.debtor.deleteContract(id)
          .then(() => {
            this.getList();
          });
    },
    getList() {
      this.rowData = [];

			let postData = {
				columns: [],
				filters: this.filters || [],
				maxResults: 25000,
				offset: 0,
				sorting: this.sorting
			};

      trackPayApi.debtor.getContracts(postData)
          .then((res) => {
            this.rowData = res.data;
          })
          .catch(this.toast);
    },
    applyFilter(filters) {
      this.filters = filters;
      this.getList();
    },
    reject() {
      this.$refs.rejectModal.show(true);
    },
    showDetail(data) {
      this.activeData = data.data;
      this.$refs.relationModal.showDetail(data);
    },
    showTrackingDetail(data) {
      this.$refs.TrackProgressModal.showTrackingDetails(data);
    },
  },
};
</script>
<style lang="scss" scoped>
.table_description {
  height: 65px;
  margin: 20px 0;
}
</style>
